import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { getTranslation } from '../translations';

type TranslationKey = Parameters<typeof getTranslation>[1];

// Custom hook to access translations based on the current language
export const useTranslation = () => {
  const language = useSelector((state: RootState) => state.language.currentLanguage);
  
  const t = (key: TranslationKey): string => {
    return getTranslation(language, key);
  };
  
  return { t, language };
}; 